import { Component, type OnDestroy, type OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { CptGoogleTagmanagerService, EcondaService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import { DataService } from '../../../../services/data.service'
import { SharedService } from '../../../../services/shared.service'
import { type TrackAndTraceVehicleDTOExtended, type VehicleDTOExtended } from '../../../../services/vehicles.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { UnreadDocumentComponent } from '../../content/unread-document/unread-document.component'
@Component({
  selector: 'customer-portal-app-navbar-second',
  standalone: true,
  templateUrl: './navbar-second.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    UnreadDocumentComponent
  ]
})
export class NavbarSecondComponent implements OnInit, OnDestroy {
  firstVehicleVin = ''
  hasFuelPriceComparison = false
  homepage: string
  vehicles: VehicleDTOExtended[]
  inactiveVehicles: VehicleDTOExtended[]
  vehiclesTNT: TrackAndTraceVehicleDTOExtended[]
  // channels: boolean
  country
  unread = 0
  hasTestView
  hasTracking
  navigationMarketplace
  sub = {
    combinedVehiclesSubscription: null
  }

  constructor (
    public dataService: DataService,
    private readonly sharedService: SharedService,
    private readonly logger: NGXLogger,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    public router: Router,
    private readonly econdaService: EcondaService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.homepage = this.remoteConfigService.get('homepage')
    this.country = this.remoteConfigService.get('country.code')
    this.hasTestView = this.remoteConfigService.get('hasTestView')
    this.hasFuelPriceComparison = Boolean(this.remoteConfigService.get('hasFuelPriceComparison'))
    this.navigationMarketplace = this.remoteConfigService.getArrayValues<any>(
      'navigationMarketplace'
    )
  }

  get hasVehicles (): boolean {
    return this.vehicles?.length > 0 || this.inactiveVehicles?.length > 0 || this.vehiclesTNT?.length > 0
  }

  get firstVehicle (): VehicleDTOExtended | TrackAndTraceVehicleDTOExtended {
    return this.vehicles?.[0] || this.vehiclesTNT?.[0] || this.inactiveVehicles?.[0]
  }

  get hasFuelPriceVehicle (): boolean {
    return this.hasFuelPriceComparison
  }

  ngOnInit (): void {
    this.sub.combinedVehiclesSubscription = this.dataService.combinedVehiclesLoaded
      .subscribe(([vehicles, inactiveVehicles, vehiclesTNT]) => {
        this.vehicles = vehicles
        this.inactiveVehicles = inactiveVehicles
        this.vehiclesTNT = vehiclesTNT?.filter(el => !(el.isHistory ?? false))

        if (this.hasVehicles) {
          this.firstVehicleVin = 'commissionNumber' in this.firstVehicle
            ? `commissionNumber-${this.firstVehicle.commissionNumber}`
            : this.firstVehicle?.vin
        }
      })
  }

  sendGTMNavigationData (label?: string, linkType?: string): void {
    this.cptGtmService.sendNavigationLinkData(
      null,
      'Sub Navigation',
      this.sharedService.translateLink(label),
      linkType
    )
    this.econdaService.send({
      content: 'Navigation',
      Target: [
        'Sub Navigation',
        this.sharedService.translateLink(label),
        1,
        'd'
      ]
    })
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }
}
